import { Tax, TaxType, TaxBase, Period } from './types'

export const systemTaxCodes = {
    iva21:        'IVA21',
    iva10_5:      'IVA10.5',
    percIva21:    'PERCIVA21',
    percIva10_5:  'PERCIVA10.5',
    percIIBBCaba: 'PERCIIBBCABA',
    percIIBBBsAs: 'PERCIIBBBSAS',
} as const

export const isSystemTax = (tax: Pick<Tax, 'code'>): boolean =>
    (Object.values(systemTaxCodes) as string[]).includes(tax.code)

type SystemTaxBase = Omit<Tax, 'companyId' | 'id'>

export const systemTaxDefinitions: SystemTaxBase[] = [
    {
        code: systemTaxCodes.iva21,
        name: 'IVA 21%',
        type: TaxType.VAT,
        taxBase: TaxBase.PRICE_WITHOUT_VAT,
        nonTaxableMin: 0,
        nonTaxableMinPeriod: Period.PER_OPERATION,
        yield: 21,
        system: true
    },
    {
        code: systemTaxCodes.iva10_5,
        name: 'IVA 10,5%',
        type: TaxType.VAT,
        taxBase: TaxBase.PRICE_WITHOUT_VAT,
        nonTaxableMin: 0,
        nonTaxableMinPeriod: Period.PER_OPERATION,
        yield: 10.5,
        system: true
    },
    {
        code: systemTaxCodes.percIva21,
        name: 'Percepción IVA 21%',
        type: TaxType.PERCEPTION,
        taxBase: TaxBase.PRICE_WITHOUT_VAT,
        nonTaxableMin: 60,
        nonTaxableMinPeriod: Period.PER_OPERATION,
        yield: 3,
        system: true
    },
    {
        code: systemTaxCodes.percIva10_5,
        name: 'Percepción IVA 10,5%',
        type: TaxType.PERCEPTION,
        taxBase: TaxBase.PRICE_WITHOUT_VAT,
        nonTaxableMin: 60,
        nonTaxableMinPeriod: Period.PER_OPERATION,
        yield: 1.5,
        system: true
    },
    {
        code: systemTaxCodes.percIIBBCaba,
        name: 'Percepción IIBB CABA',
        type: TaxType.PERCEPTION,
        taxBase: TaxBase.PRICE_WITHOUT_VAT,
        nonTaxableMin: 0,
        nonTaxableMinPeriod: Period.PER_OPERATION,
        yield: 0.1,
        system: true
    },
    {
        code: systemTaxCodes.percIIBBBsAs,
        name: 'Percepción IIBB - Bs. As.',
        type: TaxType.PERCEPTION,
        taxBase: TaxBase.PRICE_WITHOUT_VAT,
        nonTaxableMin: 0,
        nonTaxableMinPeriod: Period.PER_OPERATION,
        yield: 4,
        system: true
    },
]
